<template>
  <div class="pdf-zoom">
    <a @click.prevent.stop="zoomOut" class="icon" :disabled="isDisabled"><i class="fa fa-minus" aria-hidden="true"></i></a>
    <a @click.prevent.stop="zoomIn" class="icon" :disabled="isDisabled"><i class="fa fa-plus" aria-hidden="true"></i></a>
    <a @click.prevent.stop="fitWidth" class="icon" :disabled="isDisabled"><i class="fa fa-expand" aria-hidden="true"></i></a>
    <a @click.prevent.stop="fitAuto" class="icon" :disabled="isDisabled"><i class="fa fa-compress" aria-hidden="true"></i></a>
  </div>
</template>

<script>

export default {
  name: 'PDFZoom',

  components: {
  },

  props: {
    scale: {
      type: Number,
    },
    increment: {
      type: Number,
      default: 0.25,
    },
  },

  computed: {
    isDisabled() {
      return !this.scale;
    },
  },

  methods: {
    zoomIn() {
      if (this.scale >= 4) return;
      this.updateScale(this.scale + this.increment);
    },

    zoomOut() {
      if (this.scale <= this.increment) return;
      this.updateScale(this.scale - this.increment);
    },

    updateScale(scale) {
      this.$emit('change', {scale});
    },

    fitWidth() {
      this.$emit('fit', 'width');
    },

    fitAuto() {
      this.$emit('fit', 'auto');
    },
  },
}
</script>

<style lang="scss">
.pdf-zoom .icon{
  margin-right:15px;
  cursor: pointer;
  display: inline-block;
  color: #ffffff;
  vertical-align:middle;font-size:16px;
  &:hover{color: #ffd400;}
  &:last-child{margin-right:0px;}
}
</style>
